<template>
  <div class="page">
    <div class="page-container">
      <template v-if="!submited">
        <project-page-header ref="pageHeader" :id="projectId">
          <template v-slot:actions>
            <a-space>
              <a-button class="v-px-sm" icon="left" size="default" type="default" @click="$router.push(`../view/basic?id=${projectId}`)">返回项目详情</a-button>
            </a-space>
          </template>
        </project-page-header>
        <div class="page-title">填报财务进展数据</div>
        <div class="panel-body">
          <a-alert class="v-mb-sm no-border" type="error" v-if="record.checkResult === -1">
            <div slot="message">
              <div class="font-md text-darkblue flex items-center">
                <a-icon type="alert" class="v-mr-xs" />
                此财务进展数据已被驳回
              </div>
              <div class="flex v-mt-xs">
                <span class="text-right text-grey">审核意见：</span>
                <span class="col text-red" v-html="$utils.convertToHtml(record.checkOpinion)"></span>
              </div>
            </div>
          </a-alert>
          <div class="panel-info-section">
            <div class="panel-info-section-title">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">财务进展基本信息</span>
            </div>
            <div class="w1200">
              <a-form-model class="form-sm" ref="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }" :model="form">
                <a-row>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        本次报销金额合计
                      </span>
                      <a-input type="number" placeholder="请款金额" v-model="form.billAmount" ref="billAmount" suffix="元" disabled style="width: 300px" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 18 }">
                      <span slot="label">本次财务进展说明</span>
                      <a-textarea :auto-size="{ minRows: 4 }" v-model="form.billRemark" ref="billRemark" placeholder="进展说明" style="width: 100%" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </a-form-model>
            </div>
          </div>
          <div class="panel-info-section">
            <div class="flex items-center">
              <div class="panel-info-section-title">
                <a-icon type="caret-right" class="text-primary" />
                <span class="text-bold">本次预审票据</span>
              </div>
              <a-button size="small" class="v-ml-auto" icon="plus" type="indigo" @click="handleShowInvoiceModal()">添加票据</a-button>
            </div>
            <div class="flex">
              <div class="col">
                <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :loading="loading" :pagination="false" :data-source="invoices" :scroll="{ x: '100%' }">
                  <a-table-column title="序号" data-index="index" :width="55" align="left">
                    <template slot-scope="text, record, index">
                      {{ index + 1 }}
                    </template>
                  </a-table-column>
                  <a-table-column title="票据金额" data-index="invoiceAmount" :ellipsis="true" :width="120" align="left">
                    <template slot-scope="text, record">
                      <span>{{ $utils.thousands(record.invoiceAmount) }}</span>
                    </template>
                  </a-table-column>
                  <a-table-column title="票据说明" data-index="invoiceRemark" align="left">
                    <template slot-scope="text, record">
                      <div class="lineh-13 text-ellipsis ellipsis-3-lines" v-html="$utils.convertToHtml(record.invoiceRemark)"></div>
                    </template>
                  </a-table-column>
                  <a-table-column title="票据文件" data-index="quantity" :width="320" align="left">
                    <template slot-scope="text, record">
                      <file-container :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="record.files && projectId"></file-container>
                    </template>
                  </a-table-column>
                  <a-table-column title="费用报销明细" data-index="amount" align="left">
                    <template slot-scope="text, record">
                      <ul class="cell-list" v-if="record.budgets && record.budgets.length">
                        <li v-for="(item, idx) in record.budgets" :key="idx">
                          <a-badge color="#f24a78" />
                          {{ item.budget && item.budget.pname }} — {{ item.budget && item.budget.name }} / {{ $utils.thousands(item.amount) }} 元
                        </li>
                      </ul>
                    </template>
                  </a-table-column>
                  <a-table-column title="操作" data-index="action" :width="80" align="center">
                    <template slot-scope="text, record, index">
                      <a-space :size="10">
                        <span class="font-xs hover-line text-indigo" title="修改" @click="handleShowInvoiceModal(record, index)">修改</span>
                        <span class="font-xs hover-line text-red" title="删除" @click="handleRemoveInvoice(index)">删除</span>
                      </a-space>
                    </template>
                  </a-table-column>
                </a-table>
              </div>
            </div>
          </div>
          <div class="panel-info-section">
            <div class="panel-info-section-title flex items-center">
              <a-icon type="caret-right" class="text-primary v-mr-xs" />
              <span class="text-bold">项目预算明细表</span>
              <a-space :size="8" class="v-ml-auto">
                <a-select size="small" v-model="budgetYear" allow-clear placeholder="费用年份" style="width: 94px" @change="onBudgetYearChange">
                  <a-select-option :key="item" v-for="item in budgetYears">{{ item }}年</a-select-option>
                </a-select>
                <a-button icon="control" type="indigo" size="small" class="v-ml-auto" @click="rmbModal = true">查看费用报销比率</a-button>
              </a-space>
            </div>
            <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :data-source="tableBudgets" :loading="budgetLoading" :expanded-row-keys.sync="expandedBudgetKeys" :pagination="false" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
              <a-table-column title="序号" data-index="index" :width="60" align="left">
                <template slot-scope="text, record">
                  {{ record.no }}
                </template>
              </a-table-column>
              <a-table-column title="费用名称" data-index="name" :ellipsis="true" :width="280" align="left">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum }">{{ record.name || '-' }}</span>
                </template>
              </a-table-column>
              <a-table-column title="费用类别" data-index="cate" :width="300" align="left">
                <template slot-scope="text, record" v-if="!record.isRoot">
                  <div class="flex items-center">
                    <span class="col ellipsis" :title="record.cateFullName">{{ record.cateFullName }}</span>
                    <a-tag class="ml-auto v-pl-xs tag-tiny v-mr-none text-indigo" v-if="record.costRate != void 0">{{ record.costRate }}%</a-tag>
                  </div>
                </template>
              </a-table-column>
              <a-table-column title="费用年份" data-index="year" :width="90" align="center" :ellipsis="true">
                <template slot-scope="text, record">
                  <template v-if="!record.isRoot">{{ record.year }}</template>
                </template>
              </a-table-column>
              <a-table-column title="单价" data-index="price" :width="110" align="right" :ellipsis="true">
                <template slot-scope="text, record">
                  <template v-if="!record.isRoot">{{ record.price }}</template>
                </template>
              </a-table-column>
              <a-table-column title="数量" data-index="quantity" :width="90" align="right">
                <template slot-scope="text, record">
                  <template v-if="!record.isRoot">{{ record.quantity }}</template>
                </template>
              </a-table-column>
              <a-table-column title="预算金额" data-index="amount" :width="120" align="right">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.amount) }}</span>
                </template>
              </a-table-column>
              <a-table-column title="请款金额" data-index="applied" :width="110" align="right">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.applied) }}</span>
                </template>
              </a-table-column>
              <a-table-column title="实际已支出金额" data-index="expensed" :width="119" align="right">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.expensed) }}</span>
                </template>
              </a-table-column>
              <a-table-column title="本次预审票据金额" :custom-cell="record => ({ class: 'td-bright' })" data-index="currentExpensed" :width="130" align="right">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum, 'text-primary': record.currentExpensed }">{{ record.extra ? '' : $utils.thousands(record.currentExpensed) }}</span>
                </template>
              </a-table-column>
              <a-table-column title="累计支出金额" data-index="accuExpensed" :width="110" align="right">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.accuExpensed) }}</span>
                </template>
              </a-table-column>
              <a-table-column title="差额" data-index="subtract" :width="110" align="right">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.amount - record.expensed) }}</span>
                </template>
              </a-table-column>
              <a-table-column title="请款余额" :custom-cell="record => ({ class: 'td-bright' })" data-index="accuRemainApplied" :width="110" align="right">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum, 'text-primary': record.remainApplied != record.accuRemainApplied }">{{ record.extra ? '' : $utils.thousands(record.accuRemainApplied) }}</span>
                </template>
              </a-table-column>
              <a-table-column title="票据金额" data-index="invoiceAmount" :width="110" align="right">
                <template slot-scope="text, record">
                  <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.expensed) }}</span>
                </template>
              </a-table-column>
              <a-table-column title="票据文件" data-index="invoiceFiles" :width="330" align="left">
                <template slot-scope="text, record">
                  <file-container v-if="record.files" :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01"></file-container>
                  <template slot-scope="text, record" v-else-if="record.name == '合计'">
                    <span>
                      <b class="text-primary">{{ record.fileTotal }}</b>
                      张发票
                    </span>
                  </template>
                </template>
              </a-table-column>
            </a-table>
          </div>
          <div class="text-center v-my-lg">
            <a-space>
              <a-button icon="check" type="indigo" key="draft" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
              <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirm(true)" :loading="saving">提交审核</a-button>
              <a-button icon="left" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </div>
      </template>
      <template v-else>
        <a-result status="success" title="提交成功" sub-title="您填报的财务进展数据已提交审核，请耐心等待审核结果。">
          <template #extra>
            <a-button key="view" type="primary" @click="$router.push(`../view?id=${projectId}`)">查看项目</a-button>
            <a-button key="back" @click="$router.go(-1)">返回</a-button>
          </template>
        </a-result>
      </template>
    </div>
    <!-- 票据弹窗 -->
    <a-modal :mask-closable="false" centered destroy-on-close title="票据清单" :visible="showInvoiceModal" @cancel="handleCancelInvoiceModal" :width="1200" :body-style="{ padding: '10px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="handleCancelInvoiceModal">取消</a-button>
          <a-button type="primary" @click="handleSubmitInvoice">确认</a-button>
        </a-space>
      </template>
      <a-form-model class="form-item-xs" ref="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
        <a-form-model-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            票据金额
          </span>
          <a-input-number placeholder="票据金额" class="no-handler" disabled :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear v-model="invoiceForm.invoiceAmount" style="width: 240px" ref="recordAmount" />
        </a-form-model-item>
        <a-form-model-item :colon="false">
          <span slot="label">票据说明</span>
          <a-textarea :auto-size="{ minRows: 3 }" v-model="invoiceForm.invoiceRemark" ref="invoiceRemark" placeholder="票据说明" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item class="form-item-none" :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            票据文件
          </span>
          <a-upload
            :action="`${baseURL}/file/upload`"
            :data="{
              params: JSON.stringify({ projectId, fileType: 4, fileSign: 'P01' }),
            }"
            :file-list="invoiceForm.files"
            :before-upload="beforeUploadFile"
            @preview="handlePreviewFile"
            @change="info => handleUploadChange(info, -1, 'files')"
            list-type="picture-card"
            class="picture-uploader picture-uploader-invoice"
            accept=".png, .jpg, .jpeg, .gif, .pdf"
            ref="invoiceFiles"
          >
            <div>
              <a-icon type="plus" />
              <div class="ant-upload-text">上传发票</div>
            </div>
          </a-upload>
        </a-form-model-item>
        <a-form-model-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            费用报销明细
          </span>
          <a-button size="small" class="v-ml-auto" icon="plus" type="indigo" @click="handleShowInvoiceBudgetModal()">添加</a-button>
          <a-table key="table-edit" class="list-table" size="small" rowKey="uid" :pagination="false" :data-source="invoiceForm.budgets" :scroll="{ x: '100%' }">
            <a-table-column title="#" data-index="index" :width="45" align="center">
              <template slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table-column>
            <a-table-column title="费用明细" data-index="name" :ellipsis="true" align="left">
              <template slot-scope="text, record" v-if="record.budget">
                <span :title="`${record.budget.pname} — ${record.budget.name}`">{{ record.budget.pname }} — {{ record.budget.name }}</span>
              </template>
            </a-table-column>
            <a-table-column title="费用类别" data-index="cate" :width="240" align="left">
              <template slot-scope="text, record" v-if="record.cate">
                <span :title="record.cateFullName">{{ record.cate.cateFullName }}</span>
              </template>
            </a-table-column>
            <a-table-column title="预算金额" data-index="budgetAmount" :width="115" align="right">
              <template slot-scope="text, record" v-if="record.budget">
                {{ $utils.thousands(record.budget.amount) }}
              </template>
            </a-table-column>
            <a-table-column title="已支出金额" data-index="budgetExpensed" :width="115" align="right">
              <template slot-scope="text, record" v-if="record.budget">
                {{ $utils.thousands(record.budget.expensed) }}
              </template>
            </a-table-column>
            <a-table-column title="本次报销金额" data-index="quantity" :width="115" align="right">
              <template slot-scope="text, record">
                <span class="text-primary">{{ $utils.thousands(record.amount) }}</span>
              </template>
            </a-table-column>
            <a-table-column title="操作" data-index="action" :width="80" align="center">
              <template slot-scope="text, record, index">
                <a-space :size="10">
                  <span class="font-xs hover-line text-indigo" title="修改" @click="handleShowInvoiceBudgetModal(record, index)">修改</span>
                  <span class="font-xs hover-line text-red" title="删除" @click="handleRemoveInvoiceBudget(index)">删除</span>
                </a-space>
              </template>
            </a-table-column>
          </a-table>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 费用明细弹窗 -->
    <a-modal :mask-closable="false" centered destroy-on-close title="票据活动费用明细" :visible="showInvoiceBudgetModal" @cancel="handleCancelInvoiceBudgetModal" :width="800" :body-style="{ padding: '10px' }">
      <template slot="footer">
        <a-space>
          <a-button @click="handleCancelInvoiceBudgetModal">取消</a-button>
          <a-button type="primary" @click="handleSubmitInvoiceBudget">确认</a-button>
        </a-space>
      </template>
      <div class="v-mb-sm" v-if="invoiceBudgetForm.budgetId">
        <table class="table table-plain table-medium">
          <tbody>
            <template v-if="invoiceBudgetForm.cate && invoiceBudgetForm.cate.cateId">
              <tr>
                <th>费用分类</th>
                <template v-if="[2, 3].includes(invoiceBudgetForm.cate.cateRoot)">
                  <td>
                    {{ invoiceBudgetForm.cate.cateFullName }}
                    <a-tag class="ml-auto v-pl-xs tag-tiny v-mr-none text-indigo" v-if="invoiceBudgetForm.cate.costRate != void 0">{{ invoiceBudgetForm.cate.costRate }}%</a-tag>
                  </td>
                  <th>费用分类报销上限</th>
                  <td class="text-right">
                    {{ $utils.thousands(invoiceBudgetForm.cate.cateAmount) }} 元
                  </td>
                </template>
                <template v-else>
                  <td colspan="3">{{ invoiceBudgetForm.cate.cateFullName }}</td>
                </template>
              </tr>
              <tr>
                <th width="160">费用分类已报销金额</th>
                <td width="35%" class="text-right">{{ $utils.thousands(invoiceBudgetForm.cate.expensed) }} 元</td>
                <th width="150">本次预审费用分类<br />填报金额累计</th>
                <td class="text-right">
                  <span class="text-primary">{{ $utils.thousands(calcCateExpense()) }}</span> 元
                </td>
              </tr>
            </template>
            <template v-if="invoiceBudgetForm.budget && invoiceBudgetForm.budget.budgetId">
              <tr>
                <th width="160">费用明细预算金额</th>
                <td width="35%" class="text-right">{{ $utils.thousands(invoiceBudgetForm.budget.amount) }} 元</td>
                <th width="150">费用明细请款金额</th>
                <td class="text-right">{{ $utils.thousands(invoiceBudgetForm.budget.applied) }} 元</td>
              </tr>
              <tr>
                <th>费用明细已支出金额</th>
                <td class="text-right">{{ $utils.thousands(invoiceBudgetForm.budget.expensed) }} 元</td>
                <th>本次预审费用明细<br />填报金额累计</th>
                <td class="text-right">
                  <span class="text-primary">{{ $utils.thousands(calcBudgetExpense()) }}</span> 元
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <a-form-model class="form-item-xs" ref="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
        <a-form-model-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            活动名称
          </span>
          <a-select v-model="invoiceBudgetForm.budgetPid" ref="budget1" placeholder="请选择" style="width: 240px" @change="onBudgetChange1">
            <a-select-option v-for="item in budgets1" :key="item.budgetId">{{ item.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            费用明细
          </span>
          <a-select :dropdown-match-select-width="true" v-model="invoiceBudgetForm.budgetId" ref="budget2" placeholder="请选择" @change="onBudgetChange2" option-label-prop="label">
            <a-select-option v-for="item in budgets2" :key="item.budgetId" :label="item.name" :disabled="!item.cateId || item.cateAmount === 0">
              <div class="flex items-center" :title="item.name">
                <span class="ellipsis" style="width: 250px">{{ item.name }}</span>
                <span class="v-ml-auto v-pl-xs">{{ item.cateFullName }}</span>
                <!-- <span class="ellipsis" style="width: 250px">{{ item.cateFullName }}</span> -->
                <!-- <span class="text-green">{{ $utils.thousands(item.amount - item.expensed) }}</span> /  -->
                <!-- <div class="v-ml-auto">{{ $utils.thousands(item.manageLimitedAmount) }}</div> -->
              </div>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            票据报销金额
          </span>
          <div class="input-wrapper">
            <a-input-number placeholder="报销金额" class="no-handler" :formatter="value => $utils.numInputFormatter(value)" :parser="value => value.replace(/\$\s?|(,*)/g, '')" allow-clear v-model="invoiceBudgetForm.amount" style="width: 240px" ref="invoiceBudgetAmount" />
            <span class="input-unit">元</span>
          </div>
        </a-form-model-item>
        <a-form-model-item :colon="false">
          <span slot="label">备注说明</span>
          <a-textarea :auto-size="{ minRows: 3 }" v-model="invoiceBudgetForm.remark" ref="invoicebudgetRemark" placeholder="备注说明" style="width: 100%" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :mask-closable="false" centered title="费用报销比例" :footer="null" :visible="rmbModal" @cancel="rmbModal = false" :width="960" :body-style="{ padding: '12px' }">
      <a-table class="list-table" size="small" rowKey="uid" :pagination="false" :data-source="rmbRecords" :scroll="{ x: '100%' }" :expand-icon-column-index="1">
        <a-table-column title="序号" data-index="index" :width="60" align="left">
          <template slot-scope="text, record, index" v-if="record.isRoot && !record.sum">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="费用类别" data-index="name" :width="300" align="left">
          <template slot-scope="text, record">
            <span class="col ellipsis" v-if="record.isRoot && !record.sum">{{ record.cateFullName }}</span>
            <span :class="{ 'text-bold': record.sum }" v-else>{{ record.name || '-' }}</span>
          </template>
        </a-table-column>
        <a-table-column title="预算金额" data-index="amount" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ $utils.thousands(record.amount) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="费用报销比例" data-index="costRate" :width="120" align="right">
          <template slot-scope="text, record" v-if="record.isRoot && !record.sum">
            <a-tag class="tag-tiny text-indigo" v-if="record.costRate != void 0">{{ record.costRate }}%</a-tag>
          </template>
        </a-table-column>
        <a-table-column title="费用报销上限" data-index="costAmount" :width="110" align="right">
          <template slot-scope="text, record" v-if="record.isRoot && !record.sum">
            <span v-if="record.cateRoot == 2 && record.rmbRate != void 0">{{ $utils.thousands((record.manageAmount * record.rmbRate) / 100) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="请款金额" data-index="applied" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.applied) }}</span>
          </template>
        </a-table-column>
        <a-table-column title="实际支出金额" data-index="expensed" :width="110" align="right">
          <template slot-scope="text, record">
            <span :class="{ 'text-bold': record.sum }">{{ record.extra ? '' : $utils.thousands(record.expensed) }}</span>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import ProjectPageHeader from '../common/page-header'
import { saveProgressBill, getProgressBill, getBudgetsWithAmount } from '@/api/project/common'
import { convertBudgetsRecords, mergeTableBudgetsAndInvoices } from '@/utils/data'

const invoiceBudgetForm = {
  id: undefined,
  budgetId: undefined,
  budgetPid: undefined,
  amount: undefined,
  remark: '',
  budget: {},
  cate: {},
}

const invoiceForm = {
  invoiceAmount: 0,
  invoiceRemark: '',
  files: [],
  budgets: [],
  shares: [],
}

export default {
  name: 'FundedProjectApplyBill',
  components: {
    ProjectPageHeader,
  },
  data() {
    return {
      projectId: +this.$route.query.id,
      billId: +this.$route.query.bid,
      loading: false,
      submited: false,
      saving: false,
      invoices: [],
      budgets: [],
      budgetsTableData: [],
      budgets1: [],
      budgets2: [],
      currentRecord: {},
      form: {
        billId: undefined,
        billAmount: 0,
        billRemark: '',
      },
      invoiceForm: {
        ...invoiceForm,
      },
      invoiceIndex: -1,
      invoiceBudgetIndex: -1,
      showInvoiceModal: false,
      invoiceBudgetForm: {
        ...invoiceBudgetForm,
      },
      showInvoiceBudgetModal: false,
      record: {},
      expandedBudgetKeys: [],
      budgetLoading: false,
      budgetYears: [],
      budgetYear: undefined,
      tableBudgetsAll: [],
      tableBudgets: [],
      invoiceBudget: {},
      rmbRecords: [],
      rmbModal: false,
      subProjs: [],
    }
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id, bid } = this.$route.query
      if (id) {
        this.projectId = +id
      }
      if (bid) {
        // 草稿，预算从详情中取
        this.billId = +bid
        this.loadProgressBill()
      } else {
        this.loadBudgets()
      }
    },
    loadProgressBill() {
      getProgressBill(this.billId).then(({ data }) => {
        if (data.success) {
          let { billId, billAmount, billRemark, invoices = [], budgets = {} } = data.result
          Object.assign(this.form, { billId, billAmount, billRemark })
          this.dealBudgetRecords(budgets)
          this.record = data.result
          this.invoices = invoices.map(item => ({
            uid: item.invoiceId,
            invoiceId: item.invoiceId,
            invoiceRemark: item.invoiceRemark,
            invoiceAmount: item.invoiceAmount,
            budgets: item.invoiceBudgets.map(item => {
              const {
                budgetId,
                budgetPid,
                budget: { cateId },
              } = item
              const budget = this.budgets1.find(d => d.budgetId == budgetPid).children.find(d => d.budgetId == budgetId)
              let _item = {
                id: item.id,
                uid: item.id,
                amount: item.amount,
                budgetId,
                budgetPid,
                remark: item.remark,
                budget,
                cate: {},
              }
              if (cateId) {
                let cate = this.rmbRecords.find(d => d.cateId == cateId) || {}
                _item.cate = cate
              }
              return _item
            }),
            files: item.files.map(file => ({
              ...file,
              uid: file.fileId,
              name: this.$utils.truncateFileName(file.fileOriginName || file.fileName, 50),
              status: 'done',
              url: `${this.baseURL}/file/img?id=${file.fileId}&belongId=${this.projectId}&fileSign=P01`,
            })),
          }))
          mergeTableBudgetsAndInvoices(this.invoices, this.tableBudgetsAll)
        }
      })
    },
    loadBudgets() {
      this.budgetLoading = true
      getBudgetsWithAmount(this.projectId).then(({ data }) => {
        this.budgetLoading = false
        if (data.success) {
          this.dealBudgetRecords(data.result)
        }
      })
    },
    dealBudgetRecords(data) {
      let { records, raisedAmount, manageRate, ownManageRate } = data
      let { years, tableRecords, rmbRecords } = convertBudgetsRecords(records, { showManage: true, showOwnManage: true, raisedAmount, manageRate, ownManageRate })
      this.budgetYears = years
      this.budgets = this.$utils.cloneDeep(tableRecords)
      this.budgets1 = this.budgets.filter(d => !d.sum)
      this.tableBudgetsAll = tableRecords
      this.tableBudgets = tableRecords
      this.rmbRecords = rmbRecords
      this.expandedBudgetKeys = tableRecords.filter(d => d.children && d.children.length).map(d => d.uid)
    },
    onBudgetYearChange(value) {
      this.tableBudgets = value ? this.tableBudgetsAll.filter(item => item.sum || (item.children && item.children.some(d => d.year == value))) : this.tableBudgetsAll
    },
    sumInvoiceAmount() {
      this.invoiceForm.invoiceAmount = this.invoiceForm.budgets.map(d => d.amount).reduce((sum, d) => this.$utils.add(sum, d), 0)
    },
    sumBillAmount() {
      this.form.billAmount = this.invoices.map(d => d.invoiceAmount).reduce((sum, d) => this.$utils.add(sum, d), 0)
      mergeTableBudgetsAndInvoices(this.invoices, this.tableBudgetsAll)
      this.onBudgetYearChange()
    },
    handleUploadChange(info, count) {
      this.invoiceForm.files = this.handleUploadFile(info, count)
      this.$refs.invoiceFiles.$el.classList.remove('uploader-empty')
    },
    handleShowInvoiceBudgetModal(record, index = -1) {
      if (record) {
        const {
          budgetId,
          budgetPid,
          cate: { cateId },
        } = record
        const budgetP = this.budgets.find(d => d.budgetId == budgetPid)
        this.budgets2 = budgetP ? budgetP.children : []
        Object.assign(this.invoiceBudgetForm, {
          ...record,
          budget: this.budgets2.find(d => d.budgetId == budgetId) || {},
          cate: this.rmbRecords.find(d => d.cateId == cateId) || {},
        })
      } else {
        this.invoiceBudgetForm = this.$utils.cloneDeep(invoiceBudgetForm)
        this.budget2 = []
      }
      this.invoiceBudgetIndex = index
      this.showInvoiceBudgetModal = true
    },
    handleRemoveInvoiceBudget(index) {
      this.invoiceForm.budgets.splice(index, 1)
      this.sumInvoiceAmount()
    },
    handleCancelInvoiceBudgetModal() {
      this.showInvoiceBudgetModal = false
    },
    handleRemoveInvoice(index) {
      this.invoices.splice(index, 1)
      this.sumBillAmount()
    },
    onBudgetChange1(value) {
      this.budgets2 = this.budgets.find(d => d.budgetId == value).children
      Object.assign(this.invoiceBudgetForm, {
        budgetId: undefined,
        budget: {},
        cate: {},
      })
    },
    onBudgetChange2(value) {
      if (value) {
        let budget = this.budgets2.find(d => d.budgetId == value) || {}
        let props = {
          amount: undefined,
          budget: { ...budget },
        }
        if (budget.cateId) {
          let cate = this.rmbRecords.find(d => d.cateId == budget.cateId) || {}
          props.cate = { ...cate }
        }
        console.log('onBudgetChange2', props)
        Object.assign(this.invoiceBudgetForm, props)
      }
    },
    calcCateExpense() {
      const { add } = this.$utils
      let {
        amount,
        cate: { cateId },
      } = this.invoiceBudgetForm
      let invBgtIndex = this.invoiceBudgetIndex
      let invIndex = this.invoiceIndex
      let cateInvBudgets = this.invoices
        .filter((d, i) => i != invIndex)
        .map(d => d.budgets)
        .flat()
        .filter(d => d.cateId == cateId)
      let cateBudgets = this.invoiceForm.budgets.filter((d, i) => i != invBgtIndex && d.cate && d.cate.cateId == cateId)
      // 当前分类此次报销金额合计=此次明细报销 + 当前分类其他明细报销
      return add(
        cateInvBudgets.concat(cateBudgets).reduce((count, b) => add(count, b.amount), 0),
        amount
      )
    },
    // calcCateRootExpense() {
    //   const { add } = this.$utils
    //   let {
    //     amount,
    //     cate: { cateId },
    //     budget: { cateRoot, manageAmount, ownManageAmount }
    //   } = this.invoiceBudgetForm
    //   let invBgtIndex = this.invoiceBudgetIndex
    //   let invIndex = this.invoiceIndex
    //   let cateInvBudgets = this.invoices
    //     .filter((d, i) => i != invIndex)
    //     .map(d => d.budgets)
    //     .flat()
    //     .filter(d => d.cateRoot == cateRoot)
    //   let cateBudgets = this.invoiceForm.budgets.filter((d, i) => i != invBgtIndex && d.cate && d.cate.cateId == cateId)
    //   // 当前分类此次报销金额合计=此次明细报销 + 当前分类其他明细报销
    //   return add(
    //     cateInvBudgets.concat(cateBudgets).reduce((count, b) => add(count, b.amount), 0),
    //     amount
    //   )
    // },
    calcBudgetExpense() {
      const { add } = this.$utils
      let { budgetId, amount } = this.invoiceBudgetForm
      let invBgtIndex = this.invoiceBudgetIndex
      let invIndex = this.invoiceIndex
      let bgtInvBudgets = this.invoices
        .filter((d, i) => i != invIndex)
        .map(d => d.budgets)
        .flat()
        .filter(d => d.budgetId == budgetId)
      let bgtBudgets = this.invoiceForm.budgets.filter((d, i) => i != invBgtIndex && d.budgetId == budgetId)
      return add(
        bgtInvBudgets.concat(bgtBudgets).reduce((count, b) => add(count, b.amount), 0),
        amount
      )
    },
    handleSubmitInvoiceBudget() {
      const { budgetPid, budgetId, amount, remark, budget, cate } = this.invoiceBudgetForm
      const { amount: budgetAmount, expensed: budgetExpensed } = budget
      const { cateRoot, cateId, cateAmount, expensed: cateExpensed } = cate
      const { add } = this.$utils
      this.$message.destroy()
      if (!budgetPid) {
        this.$refs.budget1.focus()
        this.$message.warn('请选择活动分类')
        return
      }
      if (!budgetId) {
        this.$refs.budget2.focus()
        this.$message.warn('请选择费用明细')
        return
      }
      if (!amount) {
        this.$refs.invoiceBudgetAmount.focus()
        this.$message.warn('请输入报销金额')
        return
      }
      const budgetExpense = this.calcBudgetExpense()
      console.log('当前明细此次报销金额合计', budgetExpense)
      console.log('当前明细已报销金额合计', budgetExpensed)
      console.log('当前明细报销金额上限', budgetAmount)
      if (add(budgetExpense, budgetExpensed) > budgetAmount) {
        this.$refs.invoiceBudgetAmount.focus()
        this.$message.warn('此次预审当前预算明细报销金额超过预算可报销金额')
        return
      }
      if ([2, 3].includes(cateRoot) && cateId) {
        // 分类是管理费
        const cateExpense = this.calcCateExpense()
        console.log('当前分类此次报销金额合计', cateExpense)
        console.log('当前分类已报销金额合计', cateExpensed)
        console.log('当前分类报销金额上限', cateAmount)
        if (add(cateExpense, cateExpensed) > cateAmount) {
          this.$refs.invoiceBudgetAmount.focus()
          this.$message.warn('此次预审当前费用分类报销金额超过分类可报销金额')
          return
        }
      }
      const invBgtIndex = this.invoiceBudgetIndex
      this.invoiceForm.budgets.splice(invBgtIndex, invBgtIndex > -1 ? 1 : 0, {
        uid: Math.random(),
        budgetPid,
        budgetId,
        amount,
        remark,
        budget,
        cate,
      })
      this.sumInvoiceAmount()
      this.handleCancelInvoiceBudgetModal()
    },
    handleShowInvoiceModal(record, index = -1) {
      if (record) {
        this.invoiceForm = this.$utils.cloneDeep(record)
      } else {
        this.invoiceForm = this.$utils.cloneDeep(invoiceForm)
      }
      this.invoiceIndex = index
      this.showInvoiceModal = true
    },
    handleCancelInvoiceModal() {
      this.showInvoiceModal = false
    },
    handleSubmitInvoice() {
      let { invoiceAmount, invoiceRemark, files, budgets } = this.invoiceForm
      this.$message.destroy()
      if (files.length == 0) {
        this.$refs.invoiceFiles.$el.classList.add('uploader-empty')
        this.$message.warn('请上传票据文件')
        return
      }
      if (budgets.length == 0) {
        this.$message.warn('请添加费用报销明细')
        return
      }
      let index = this.invoiceIndex
      this.invoices.splice(index, index > -1 ? 1 : 0, {
        uid: Math.random(),
        invoiceAmount,
        invoiceRemark,
        files,
        budgets,
      })
      this.handleCancelInvoiceModal()
      this.sumBillAmount()
    },
    handleConfirm(nextStep) {
      this.$message.destroy()
      if (this.invoices.length == 0) {
        this.$message.warn('未添加报销票据')
        return
      }
      this.$confirm({
        title: nextStep ? '确认提交财务进展数据？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { projectId } = this
      let billId = this.billId
      let { billAmount, billRemark } = this.form
      let invoices = this.invoices.map(d => ({
        invoiceAmount: d.invoiceAmount,
        invoiceRemark: d.invoiceRemark,
        fileIds: d.files.map(d => d.fileId),
        invoiceBudgets: d.budgets.map(d => ({
          budgetId: d.budgetId,
          budgetPid: d.budgetPid,
          amount: d.amount,
          remark: d.remark,
        })),
      }))
      let params = {
        billId,
        projectId,
        billAmount,
        billRemark: billRemark.trim(),
        nextStep,
        invoices,
        origin: 2,
      }
      this.saving = true
      saveProgressBill(params)
        .then(({ data }) => {
          if (data.success) {
            if (nextStep) {
              this.submited = true
            } else {
              this.$message.success('操作成功')
              this.billId = data.result
              this.$router.push(`../view/finance?id=${projectId}`)
            }
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: record.isRoot == 1,
        },
      }
    },
  },
  created() {
    this.init()
  },
}
</script>
